import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { userSignIn, getCurrentUser, userSignOut } from './firebase';
import {
  STATUS_IDLE,
  STATUS_FETCHING,
  STATUS_ERROR,
  STATUS_READY
} from './constants';

export const signIn = createAsyncThunk('signIn', async ({ email, password }) => await userSignIn(email, password));

export const checkLogin = createAsyncThunk('checkLogin', async () => await getCurrentUser());

export const signOut = createAsyncThunk('signOut', async () => await userSignOut());

const accountSlice = createSlice({
  name: 'account',
  initialState: {
    status: {
      checkLogin: STATUS_IDLE,
      signIn: STATUS_IDLE,
      signOut: STATUS_IDLE
    },
    data: null
  },
  reducers: {},
  extraReducers (builder) {
    builder
      .addCase(signIn.pending, (state, action) => {
        state.status.signIn = STATUS_FETCHING
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.status.signIn = STATUS_READY
        state.data = action.payload
      })
      .addCase(signIn.rejected, (state, action) => {
        state.status.signIn = STATUS_ERROR
        state.error = action.error.message
      })
      .addCase(checkLogin.pending, (state, action) => {
        state.status.checkLogin = STATUS_FETCHING
      })
      .addCase(checkLogin.fulfilled, (state, action) => {
        if (action.payload) {
          state.status.checkLogin = STATUS_READY;
          state.data = action.payload;
        }
      })
      .addCase(checkLogin.rejected, (state, action) => {
        state.status.checkLogin = STATUS_ERROR
        state.error = action.error.message
      })
      .addCase(signOut.pending, (state, action) => {
        state.status.signOut = STATUS_FETCHING
      })
      .addCase(signOut.fulfilled, (state, action) => {
        state.status.signOut = STATUS_READY;
        state.data = null;
      })
      .addCase(signOut.rejected, (state, action) => {
        state.status.signOut = STATUS_ERROR
        state.error = action.error.message
      })
  }
})

export default accountSlice.reducer
